import React, { useRef, useState } from "react";

const MAX_DURATION = 30 * 60; // 30 minutes

export default function VideoRecorder() {
  const videoRef = useRef(null);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);
  const timerRef = useRef(null);

  const [recording, setRecording] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [videoURL, setVideoURL] = useState(null);
  const [videoBlob, setVideoBlob] = useState(null);

  const [spo2, setSpo2] = useState("");
  const [sys, setSys] = useState("");
  const [dia, setDia] = useState("");

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  // ▶ START RECORDING
  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { width: 640, height: 480 },
      audio: false,
    });

    videoRef.current.srcObject = stream;

    recorderRef.current = new MediaRecorder(stream, {
      mimeType: "video/webm",
    });

    chunksRef.current = [];

    recorderRef.current.ondataavailable = (e) => {
      if (e.data.size > 0) chunksRef.current.push(e.data);
    };

    recorderRef.current.start();
    setRecording(true);
    setSeconds(0);

    timerRef.current = setInterval(() => {
      setSeconds((prev) => {
        if (prev >= MAX_DURATION) stopRecording();
        return prev + 1;
      });
    }, 1000);
  };

  // ⏹ STOP RECORDING
  const stopRecording = () => {
    clearInterval(timerRef.current);
    recorderRef.current.stop();

    videoRef.current.srcObject.getTracks().forEach((t) => t.stop());

    recorderRef.current.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: "video/webm" });
      setVideoBlob(blob);
      setVideoURL(URL.createObjectURL(blob));
    };

    setRecording(false);
  };

  // 📤 SUBMIT TO API
  const submitData = async () => {
    if (!videoBlob || !spo2 || !sys || !dia) {
      alert("Please record video and enter all vitals.");
      return;
    }

    try {
      setLoading(true);
      setStatus("");

      const formData = new FormData();
      formData.append("video", videoBlob, "face_video.webm");
      formData.append("spo2", spo2);
      formData.append("sbp", sys);
      formData.append("dbp", dia);

      const response = await fetch(
        "https://www.careplus.gopillz.com/upload-vitals",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Upload failed");

      const result = await response.json();
      console.log(result);
      setStatus("✅ Data uploaded successfully!");
    } catch (error) {
      console.error(error);
      setStatus("❌ Upload failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <video ref={videoRef} autoPlay muted className="video" />

      <div className="controls">
        {!recording ? (
          <button onClick={startRecording}>▶ Start Recording</button>
        ) : (
          <button onClick={stopRecording}>⏹ Stop Recording</button>
        )}

        <span>
          {Math.floor(seconds / 60)}:
          {("0" + (seconds % 60)).slice(-2)}
        </span>
      </div>

      {videoURL && (
        <video src={videoURL} controls className="video" />
      )}

      <div className="form">
        <h3>Enter Vitals</h3>

        <label>SpO₂ (%)</label>
        <input
          type="number"
          placeholder="98"
          value={spo2}
          onChange={(e) => setSpo2(e.target.value)}
        />

        <label>Blood Pressure</label>
        <div className="bp">
          <input
            type="number"
            placeholder="Systolic"
            value={sys}
            onChange={(e) => setSys(e.target.value)}
          />
          <input
            type="number"
            placeholder="Diastolic"
            value={dia}
            onChange={(e) => setDia(e.target.value)}
          />
        </div>

        <button className="submit" onClick={submitData} disabled={loading}>
          {loading ? "Uploading..." : "Submit"}
        </button>

        {status && <p className="status">{status}</p>}
      </div>
    </div>
  );
}
